import * as React from "react";
const SvgFiRrSquirrel = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-squirrel_svg__a)">
      <path
        fill="#062147"
        d="M23.521 14.146a10.4 10.4 0 0 0-2.112-.984c-.843-.282-1.409-1.05-1.409-1.91v-.798c2.108-.22 4-1.234 4-3.204 0-1.937-1.904-4.75-4.889-4.75H19V.726a.727.727 0 0 0-.959-.686A3 3 0 0 0 16 2.882v1.006A3.92 3.92 0 0 0 15 6.5c0 .617-1.683 1.71-3.035 2.588-2.911 1.89-6.886 4.473-6.963 8.95C3.118 14.647 2.015 10.31 2 6.086c-.007-1.921 1.337-3.657 3.225-4.013A4.006 4.006 0 0 1 10 6a1 1 0 0 0 1.998.059C11.928 3.07 9.764.432 6.789.05A6.006 6.006 0 0 0 0 6c0 7.615 2.983 12.78 4.266 14.647a7.72 7.72 0 0 0 4.04 2.985c.758.24 1.56.367 2.379.367H21a1 1 0 0 0 0-2h-3.003a4.97 4.97 0 0 0 1.003-3c0-2.757-2.243-5-5-5a1 1 0 1 0 .023 2c.879-.02 1.767.232 2.276.949 1.722 2.425.013 5.052-2.298 5.052h-3.315a5.9 5.9 0 0 1-1.672-.242c-1.354-.79-2.013-1.963-2.013-3.587 0-3.473 3.216-5.562 6.054-7.405 1.056-.686 2.006-1.303 2.709-1.947a4.13 4.13 0 0 0 2.237 1.533v.9c0 1.723 1.115 3.253 2.775 3.808a8.3 8.3 0 0 1 1.703.794 1 1 0 0 0 1.042-1.708M19.111 8.5C17.947 8.5 17 7.603 17 6.5s.947-2 2.111-2C20.875 4.5 22 6.306 22 7.25c0 .862-1.689 1.25-2.889 1.25"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-squirrel_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrSquirrel;
